import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=8ca9055e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=8ca9055e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca9055e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ca9055e')) {
      api.createRecord('8ca9055e', component.options)
    } else {
      api.reload('8ca9055e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=8ca9055e&scoped=true&", function () {
      api.rerender('8ca9055e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n1n1Tw2dFAm3/JS/comp/SearchFilterTokens.vue"
export default component.exports